// Tarih sorusu biçimi (Finar İ8). `options.format`: "YYYY-MM-DD" (tam tarih, varsayılan) ya da
// "MM-YYYY" (ay/yıl — dönem). Değer saklama biçimi ISO: tam tarih "2025-03-31", ay/yıl
// "2025-03" (`<input type="month">` çıktısı). FormManager "MM-YYYY (ay/yıl)" seçeneği
// eskiden yalnız önizlemede çalışıyordu; form ve sunucu her zaman tam tarih istiyordu.

export type DateQuestionFormat = "YYYY-MM-DD" | "MM-YYYY";

const FULL_DATE_RE = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;
const MONTH_YEAR_RE = /^\d{4}-(0[1-9]|1[0-2])$/;

/** Soru/parça seçeneklerinden tarih biçimi; tanınmayan/eksik → tam tarih. */
export function readDateFormat(options: unknown): DateQuestionFormat {
  const f = (options as { format?: unknown } | null | undefined)?.format;
  return f === "MM-YYYY" ? "MM-YYYY" : "YYYY-MM-DD";
}

/** Biçime uymayan değer için Türkçe hata; uyarsa null. */
export function dateValueError(value: string, format: DateQuestionFormat): string | null {
  if (format === "MM-YYYY") {
    return MONTH_YEAR_RE.test(value) ? null : "Bu soru ay/yıl ister (YYYY-AA, ör. 2025-03)";
  }
  return FULL_DATE_RE.test(value) ? null : "Tarih YYYY-AA-GG formatında olmalı (ör. 2025-03-31)";
}

/** Değer ay/yıl biçiminde mi ("YYYY-MM", ay 01-12)? Yazım sırasında yarım değer gönderilmez. */
export function isMonthYearValue(value: string): boolean {
  return MONTH_YEAR_RE.test(value);
}

/**
 * Yazma yolu normalizasyonu (geri uyumluluk): ay/yıl sorusuna gelen GEÇERLİ tam tarih
 * ("2024-12-31" — eski `type=date` döneminden kalan / önceki yıldan kopyalanan / aktarılan)
 * "2024-12"ye indirgenir. Diğer her değer olduğu gibi döner (doğrulama ayrıca koşar).
 */
export function normalizeDateValue(value: unknown, format: DateQuestionFormat): unknown {
  if (format === "MM-YYYY" && typeof value === "string" && FULL_DATE_RE.test(value)) {
    return value.slice(0, 7);
  }
  return value;
}

/**
 * Renderer'a verilecek değer: ay/yıl sorusunda eski/aktarılmış tam tarih ("2025-03-31")
 * ay kısmına indirgenir ki `<input type="month">` boş görünmesin. Tam tarih sorusunda aynen.
 */
export function dateInputValue(value: string | null, format: DateQuestionFormat): string {
  if (!value) return "";
  if (format === "MM-YYYY" && /^\d{4}-\d{2}-\d{2}$/.test(value)) return value.slice(0, 7);
  return value;
}
